import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { LoadingService } from '../../../core/services/loading.service';

/**
 * A thin indeterminate bar pinned to the very top of the viewport while API calls are in flight.
 *
 * <p>Deliberately *not* a blocking overlay: the portal's reads are frequent and mostly quick, and
 * a modal spinner over every one of them would make the app feel slower than it is. The bar sits
 * above the sticky portal header but below SweetAlert2's dialogs, so a session-expired modal is
 * never underlined by it.
 */
@Component({
  selector: 'app-loading-bar',
  template: `
    @if (loading.visible()) {
      <div
        class="loading-bar"
        role="progressbar"
        aria-label="กำลังโหลดข้อมูล"
        aria-busy="true"
      >
        <div class="loading-bar__fill"></div>
      </div>
    }
  `,
  styleUrl: './loading-bar.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoadingBar {
  protected readonly loading = inject(LoadingService);
}
